import { ArrowRight } from 'pcln-icons';
import React from 'react';
import styled from 'styled-components';
import { Box } from '../../Box/Box';
import { Flex } from '../../Flex/Flex';
import { Text } from '../../Text/Text';
import { getPaletteColor } from '../../utils/utils';
import { ChipContentWrapper } from '../ChipContentWrapper';
const ImageWrapper = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "ChipContent__ImageWrapper",
  componentId: "sc-1pn2o3i-0"
})(["background-color:", ";border-radius:", "px;", ""], getPaletteColor('background.lightest'), ({
  theme
}) => theme.radii[2], ({
  disabled
}) => disabled && 'opacity: .33;');
/**
 * @public
 */
export function ChipContent({
  disabled,
  selected,
  children,
  label,
  /* eslint-disable @typescript-eslint/naming-convention */
  Icon,
  /* eslint-disable @typescript-eslint/naming-convention */
  IconTitle,
  facet,
  action,
  image,
  size,
  bridgeLabel,
  /* eslint-disable @typescript-eslint/naming-convention */
  BridgeIcon,
  variation,
  topLabel,
  borderRadius,
  justifyContent = 'center',
  ...props
}) {
  return React.createElement(ChipContentWrapper, {
    "data-testid": 'chipContentWrapper',
    hasChildren: Boolean(children),
    hasTopLabel: Boolean(topLabel),
    borderRadiusOverride: borderRadius,
    disabled: disabled,
    selected: selected,
    size: size,
    variation: variation,
    justifyContent: justifyContent,
    ...props
  }, children, React.createElement(Flex, {
    alignItems: 'center',
    height: '100%'
  }, Boolean(image) && React.createElement(ImageWrapper, {
    disabled: disabled
  }, image), Boolean(Icon) && React.createElement(Icon, {
    title: IconTitle,
    size: '20px'
  }), React.createElement(Box, null, Boolean(topLabel) && React.createElement(Text, {
    regular: true,
    ml: 2,
    mb: 1,
    fontWeight: 'bold'
  }, topLabel), React.createElement(Flex, null, Boolean(label) && React.createElement(Text, {
    regular: true,
    ml: Boolean(Icon) || Boolean(image) ? 2 : 0
  }, label), Boolean(facet) && React.createElement(Text, {
    regular: true,
    ml: 1
  }, facet), Boolean(bridgeLabel) && React.createElement(BridgeIcon, {
    title: 'to',
    size: '16px',
    ml: 2,
    mt: '1px'
  }), Boolean(bridgeLabel) && React.createElement(Text, {
    regular: true,
    ml: 2
  }, bridgeLabel))), Boolean(action?.Icon) && action.title && React.createElement(action.Icon, {
    title: action.title,
    size: '16px',
    ml: 2
  })));
}
ChipContent.defaultProps = {
  BridgeIcon: ArrowRight,
  size: 'sm',
  color: 'primary',
  py: 1,
  m: 0
};
ChipContent.displayName = 'Chip';